<template>
    <div class='page_content'>
        <div class="content">
            <div class="chat-page-wrapper">
                <database-query  :databaseTable="databaseTable" :title="title" :suggestions="suggestions"/>
            </div>
        </div>
    </div>
</template>

<script>
import databaseQuery from '@/components/databaseQuery.vue'

export default {
    name: 'aiZJLAnalysis',
    components: {
        databaseQuery
    },
    data() {
        return {
            title: '',
            databaseTable: 'lx_zjl',
            suggestions: ['本月的销售数据分析', '分析一下本月的采购数据']
        }
    },
    mounted() {
        this.title=JSON.parse(sessionStorage.getItem('savePage')).jurName
    },
    methods: {
    }
}
</script>

<style scoped>
.page_content {
    height: 100%;
    padding: 0;
    margin: 0;
}

.content {
    height: 100%;
    padding: 0;
}

.chat-page-wrapper {
    width: 100%;
    height: 100vh;
}
</style>
